import { AppBackground, Button, HeaderWithBack, LocationCard, LocationCardDataProps, PetPicture, Text, ResponsiveLogo } from '@ui/components'
import React, { useEffect, useMemo, useState } from 'react'
import { ReactComponent as MapPin } from '@/assets/icons/pin_filled.svg'
import { setLoading, useAppDispatch, useAppSelector } from '@front/store'
import { useSos } from '@front/logic'
import { ScrollView, TouchableOpacity, View } from 'react-native'
import {
  ButtonsContainer,
  Container,
  DataContainer,
  ItemContainer,
  ItemText,
  ItemTitle,
  NameContainer,
  NameText,
  PairItemContainer,
  PinContainer,
  PublicInfoContainer,
  SectionContainer,
  SectionTitle,
  SosLocationContainer,
  SosText,
  TitleUnderLine,
  UnderlineContainer,
} from './styles'
import { useNavigate } from 'react-router-dom'
import { HeaderWithBackAena } from '../../components/headerwithback'
import { t } from 'i18next'
import i18n from 'i18next'

interface DogData {
  greetings: string | undefined
  avatar: string
  name: string | undefined
  isPetLost: boolean
  activeSos: {
    guid?: string
    address?: string
    lat?: number
    lon?: number
  },
  info: {
    pet?: {
      id?: string
      name?: string
      gender?: string
      breed?: string
    },
    owner?: {
      name?: string
      phone?: string
      email?: string
      adress?: string
    }
  },

  sections: {
    title: string
    items: { title: string; value: string }[]
  }[],
}

const AenaSos: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const { getDetail, resolveSos } = useSos({})

  const [dogToPublish, setDogToPublish] = useState<DogData>()
  

  const fetchDataToPublish = async () => {
    dispatch(setLoading(true))
    const { data, success: _ } = await getDetail()
    console.log(data)
    const dog: DogData = {
      avatar: data?.avatar ? data.avatar : '',
      greetings: data?.greetings,
      name: data?.name,
      isPetLost: !!data?.activeSOS,
      activeSos: {
        lat: data?.activeSOS?.lat,
        lon: data?.activeSOS?.lon,
        guid: data?.activeSOS?.guid,
        address: data?.activeSOS?.address,
      },
      sections: data?.sections ?? [],
      info: {
        pet: {
          id: data?.info?.pet?.id ?? "",
          name: data?.info?.pet?.name ?? "",
          breed: data?.info?.pet?.breed ?? "",
          gender: data?.info?.pet?.gender ?? "",
        },
        owner: {
          name: data?.info?.owner?.name ?? "",
          email: data?.info?.owner?.email ?? "",
          phone: data?.info?.owner?.phone ?? "",
          adress: data?.info?.owner?.adress ?? "",
        }
      }
    }
    setDogToPublish(dog)
    dispatch(setLoading(false))
  }

  const handleRightButton = async () => {
    await resolveSos()
    setTimeout(() => {
      fetchDataToPublish()
    }, 500)
  }

  const { guid: petGUID } = useAppSelector((state) => state.selectedPet)

  useEffect(() => {
    fetchDataToPublish()
  }, [])

  const onSosPress = () => {
    navigate('selectlocation')
  }

  const onHistoryPress = () => {
    navigate('history')
  }

  const handleMap = () => {
    // La ruta del mapa es 'sos/history/map'; desde /aena/sos hay que navegar relativo
    // a 'history/map' (antes iba a 'map' -> /aena/sos/map, ruta inexistente -> pantalla en blanco).
    navigate('history/map', {
      state: {
        sosGuid: dogToPublish?.activeSos.guid || '',
      },
    })
  }

  const card: LocationCardDataProps = useMemo(() => {
    return {
      name: dogToPublish?.name,
      imageUrl: `https://maps.googleapis.com/maps/api/staticmap?center=${dogToPublish?.activeSos?.lat},${dogToPublish?.activeSos?.lon}&zoom=16&size=500x500&markers=color:red%7Clabel:C%7C${dogToPublish?.activeSos?.lat},${dogToPublish?.activeSos?.lon}&key=AIzaSyCydlBSzE5sbL00JEoEf4BBviSduFu5rdk`,
      location: {
        name: dogToPublish?.activeSos.address,
        latitude: dogToPublish?.activeSos.lat,
        longitude: dogToPublish?.activeSos.lon,
        latitudeDelta: 0,
        longitudeDelta: 0,
      },
    } as any
  }, [dogToPublish])

  const showActiveSearch = useMemo(() => {
    return dogToPublish?.isPetLost && dogToPublish.activeSos.lat && dogToPublish.activeSos.lon
  }, [dogToPublish])

  if (!dogToPublish) {
    return null
  }


  return (
    <AppBackground isSafe>
      <ScrollView>
        <Container>
          <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: 16, gap: 16 }}>
            <ResponsiveLogo
              breakpoint={820}
              hysteresis={20}
              large={{ width: 680, height: 96 }}
              small={{ width: 360, height: 48 }}
            />
          </View>
          <HeaderWithBackAena title={t('common.petpasssos')} />
          <PetPicture src={dogToPublish?.avatar || ''} showState={false} isWeb />
          <NameContainer>
            <NameText type="H3" fontFamily="bold" fontWeight="bold">
              {t('common.hello_iam') + ' ' + dogToPublish?.name}
            </NameText>
            <SosText type="H3" fontFamily="bold" fontWeight="bold">
              {'SOS'}
            </SosText>
            <ButtonsContainer>
              {dogToPublish?.isPetLost ? (
                <Button
                  title={t('common.sosresolved')}
                  size="block"
                  textType="cta_medium"
                  color="success"
                  textColor="background0"
                  borderRadius={10}
                  onPress={handleRightButton}
                  textStyle={{ paddingHorizontal: 20 }}
                />
              ) : (
                <Button
                  title={t('common.reportsos')}
                  size="block"
                  textType="cta_medium"
                  color="error"
                  textColor="background0"
                  borderRadius={10}
                  onPress={onSosPress}
                  textStyle={{ paddingHorizontal: 20 }}
                />
              )}
            </ButtonsContainer>
          </NameContainer>
          <PublicInfoContainer>
            <DataContainer>
              <SectionContainer>
                <UnderlineContainer>
                  <SectionTitle type="H4">{t('common.petinformation')}</SectionTitle>
                </UnderlineContainer>
                <ItemContainer>
                  <PairItemContainer>
                    <ItemTitle type="caption" fontFamily="bold" fontWeight="bold">{t('common.id') + ': '}</ItemTitle>
                    <ItemText type="caption">{dogToPublish?.info?.pet?.id}</ItemText>
                  </PairItemContainer>
                  <PairItemContainer>
                    <ItemTitle type="caption" fontFamily="bold" fontWeight="bold">{t('common.name') + ': '}</ItemTitle>
                    <ItemText type="caption">{dogToPublish?.info?.pet?.name}</ItemText>
                  </PairItemContainer>
                  <PairItemContainer>
                    <ItemTitle type="caption" fontFamily="bold" fontWeight="bold">{t('common.breed') + ': '}</ItemTitle>
                    <ItemText type="caption">{dogToPublish?.info?.pet?.breed}</ItemText>
                  </PairItemContainer>
                  <PairItemContainer>
                    <ItemTitle type="caption" fontFamily="bold" fontWeight="bold">{t('common.gender') + ': '}</ItemTitle>
                    <ItemText type="caption">{dogToPublish?.info?.pet?.gender == "Macho" ? t("common.male") : t("common.female")}</ItemText>
                  </PairItemContainer>
                </ItemContainer>
              </SectionContainer>
              <SectionContainer>
                <UnderlineContainer>
                  <SectionTitle type="H4">{t('common.ownerinformation')}</SectionTitle>
                </UnderlineContainer>
                <ItemContainer>
                  <PairItemContainer>
                    <ItemTitle type="caption" fontFamily="bold" fontWeight="bold">{t('common.name') + ': '}</ItemTitle>
                    <ItemText type="caption">{dogToPublish?.info?.owner?.name}</ItemText>
                  </PairItemContainer>
                  <PairItemContainer>
                    <ItemTitle type="caption" fontFamily="bold" fontWeight="bold">{t('common.email') + ': '}</ItemTitle>
                    <ItemText type="caption">{dogToPublish?.info?.owner?.email}</ItemText>
                  </PairItemContainer>
                  <PairItemContainer>
                    <ItemTitle type="caption" fontFamily="bold" fontWeight="bold">{t('common.phone') + ': '}</ItemTitle>
                    <ItemText type="caption">{dogToPublish?.info?.owner?.phone}</ItemText>
                  </PairItemContainer>
                  <PairItemContainer>
                    <ItemTitle type="caption" fontFamily="bold" fontWeight="bold">{t('common.address') + ': '}</ItemTitle>
                    <ItemText type="caption">{dogToPublish?.info?.owner?.adress}</ItemText>
                  </PairItemContainer>
                </ItemContainer>
              </SectionContainer>
              <Button onPress={() => navigate(`/aena/pet/owner/edit`)} title={t('common.editdata')} textType="cta_small" size="medium" textColor="white" color="aena" borderRadius={10} />
            </DataContainer>
          </PublicInfoContainer>
          {showActiveSearch ? (
            <SosLocationContainer>
              <UnderlineContainer addHorizontalMargin>
                <TitleUnderLine type="H4" fontFamily="bold" fontWeight="bold">{t('common.sosactive')}</TitleUnderLine>
                <TouchableOpacity onPress={onHistoryPress}>
                  <Text type="caption" color="primary" fontFamily="bold" fontWeight="bold">{t('common.viewall')}</Text>
                </TouchableOpacity>
              </UnderlineContainer>
              <LocationCard
                data={card}
                onPress={handleMap}
                pinIcon={<PinContainer>{<MapPin width={15} height={15} />}</PinContainer>}
                isWeb
              />
            </SosLocationContainer>
          ) : (
            <Button
              onPress={onHistoryPress}
              title={t('common.viewall')}
              textType="cta_small"
              size="medium"
              textColor="white"
              color="aena"
              borderRadius={10}
            />
          )}
        </Container>
      </ScrollView>
    </AppBackground>
  )
}

export default AenaSos
